export default __webpack_public_path__ + "static/media/product-tour2.fa6b89f1.svg";